import styled from 'styled-components'

export const Container = styled.div`
  height: 500px;
  #tradingview_39555{
    height: 100%;
  }
`